module.exports = __webpack_public_path__ + "dist/assets/redesign/ui/components/intro/img/intro-screen-2__a0581a3809d8c6fa34db40e204fd9611.png";